import React, { useRef } from 'react';
import { useLanguage } from '../../../hooks/useLanguage';
import { useAppState } from '../../../contexts/AppStateContext';
import { useFileHandler } from '../../../hooks/useFileHandler';

const FileImport = () => {
  const { t } = useLanguage();
  const { state } = useAppState();
  const { importFile } = useFileHandler();
  const fileInputRef = useRef(null);

  const handleImportClick = () => {
    if (state.isTesting) return;
    fileInputRef.current?.click();
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      importFile(file);
    }
    e.target.value = '';
  };

  return (
    <>
      <button
        className="btn-base btn-sm btn-ghost"
        onClick={handleImportClick}
        disabled={state.isTesting}
        title={t('importFile')}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14,2 14,8 20,8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
          <polyline points="10,9 9,9 8,9" />
        </svg>
      </button>
      <input
        ref={fileInputRef}
        type="file"
        accept=".txt"
        style={{ display: 'none' }}
        onChange={handleFileSelect}
      />
    </>
  );
};

export default FileImport;
